export const getStaticImage = (image: string): string => {
  const staticUrl = process?.env?.PUBLIC_URL ?? "/public";
  return `${staticUrl}/img/${image}`;
};
